// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalConfirmGacha_root__3SVwM","point":"ModalConfirmGacha_point__2Ztgd","rotate":"ModalConfirmGacha_rotate__1UGP0"};